

/* eslint-disable jsx-a11y/anchor-is-valid, no-plusplus, no-unsafe-finally, consistent-return, no-nested-ternary */

import React, { useEffect, useMemo, useRef, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import InnovateChallengeCard from 'components_newui/challenge_card/InnovateChallengeCard';
import defaultImg from 'img/hero_image.png';
import EmptyState from './EmptyState';
import LoadMoreButton from './LoadMoreButton';
import { CHALLENGE_LOAD_MORE_SIZE, CHALLENGE_PAGE_SIZE } from 'common_constants/Ideas';



const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1.5rem',
    marginBottom: '8px',
    textAlign: 'left',
  },
  filterContainer: { marginBottom: '1rem' },
  grid3block: {
    marginBottom: '1rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1rem',
  },
  textsmall: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '0.8rem',
    color: '#333',
  },
  viewlink:{
    backgroundColor:'#e60000',
    border:'1px solid #e60000',
    color:'#fff',
    // width: '100%',
    display: 'block',
    padding: '1rem',
    'box-sizing': 'border-box',
    textAlign: 'center',
    fontSize: '1rem',
    fontFamily: "VodafoneRg-Regular",
    borderRadius:'5px',
    transition:'all 300ms ease',
    marginTop:'2rem',
    '&:hover':{
      background:'transparent',
      border:'1px solid #e60000',
      color:'#333'
    },
    '&:disabled':{
        opacity:0.3,
        'pointer-events':'none'
      }
  },

}));

const STATUS_TO_API = Object.freeze({
  Active: 'ACTIVE',
  Finished: 'FINISHED',
  Draft: 'DRAFT',
});

/**
 * Props:
 * - listInnovateChallengeData?: Challenge[]             // initial/fallback
 * - innovateCategoryTypes: { id: number|string, name: string }[]
 * - isAdmin: boolean
 * - getInnovateChallengeFilterListFn: (statusConstant: string, offset: number, limit: number) =>
 *        Promise<{ items: Challenge[], totalCount?: number }>
 */
// const RenderInnovateChallenge = ({
//   listInnovateChallengeData = [],
//   innovateCategoryTypes = [],
//   isAdmin,
//   getInnovateChallengeFilterListFn,
//   enableIsHackathon
// }) => {
//   const classes = useStyles();
 
//   const [statusFilter, setStatusFilter] = useState('Active');

//   // Remote data and paging
//   const [remoteChallenges, setRemoteChallenges] = useState([]);
//   const [offset, setOffset] = useState(0);
//   const [limit] = useState(6); // PAGE SIZE — tune for your grid (e.g., 9 or 12)
//   const [hasMore, setHasMore] = useState(true);
//   const [totalCount, setTotalCount] = useState(undefined);

//   // UX state
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const statusOptions = useMemo(
//     () => (isAdmin ? ['Active', 'Draft', 'Finished'] : ['Active', 'Finished']),[isAdmin]
//   );

//   // Reset paging when status changes
//   useEffect(() => {
//     setOffset(0);
//     setRemoteChallenges([]);
//     setHasMore(true);
//     setTotalCount(undefined);
//   }, [statusFilter]);

//   // Fetch page-by-offset whenever offset or status changes
//   useEffect(() => {
//     const apiKey = STATUS_TO_API[statusFilter];
//     if (typeof getInnovateChallengeFilterListFn !== 'function' || !apiKey) return;

//     const controller = new AbortController();

//     const run = async () => {
//       try {
//         setLoading(true);
//         setError('');

//          await getInnovateChallengeFilterListFn(apiKey, offset,limit,enableIsHackathon);
//         if (controller.signal.aborted) return;

//         const batch = Array.isArray(listInnovateChallengeData?.data) ? listInnovateChallengeData?.data : [];
//         const newTotal = typeof listInnovateChallengeData?.total === 'number' ? listInnovateChallengeData?.total : undefined;

//         // Append batch
//         setRemoteChallenges((prev) => Array.from(new Set([...prev, ...batch])));

//         // Track total count if provided
//         if (typeof newTotal === 'number') {
//           setTotalCount(newTotal);
//           const loaded = (offset + batch.length);
//           setHasMore(loaded < newTotal);
//         } else {
//           // Fallback: if batch smaller than limit, we reached the end
//           setHasMore(batch.length === limit);
//         }
//       } catch (e) {
//         if (controller.signal.aborted) return;
//         setError('Failed to load challenges.');
//         // On error, you may choose to stop "hasMore" to avoid repeated failing calls
//         setHasMore(false);
//       } finally {
//         if (!controller.signal.aborted) setLoading(false);
//       }
//     };

//     run();

//     return () => controller.abort();
//   }, [statusFilter, offset, limit]);

//   // Source: remote (preferred), fallback to initial when remote empty and offset===0
//   const sourceChallenges =
//     remoteChallenges.length > 0
//       ? remoteChallenges
//       : offset === 0
//       ? listInnovateChallengeData.data
//       : [];

//   // Defensive filter (safe even if backend already filters)
//   const filteredChallenges = (sourceChallenges ?? []).filter(
//     (ch) => ch?.status?.toLowerCase() === statusFilter.toLowerCase()
//   );

//   const visibleChallenges = filteredChallenges; // with offset API, we already append pages
//   const visibleCount = visibleChallenges.length;
//   const totalLabel =
//     typeof totalCount === 'number' ? totalCount : (visibleCount + (hasMore ? '+' : ''));


//     console.log("hasMore==>", hasMore)

//   return (
//     <>
//       <h2 className={classes.title}>All Challenges</h2>

//       <div className={classes.filterContainer}>
//         <p>Filter Challenges by Status</p>
//         <div style={{ marginBottom: '1rem' }}>
//           {statusOptions.map((status) => (
//             <button
//               type="button"
//               key={status}
//               onClick={() => setStatusFilter(status)}
//               disabled={loading}
//               style={{
//                 marginRight: '10px',
//                 padding: '6px 12px',
//                 backgroundColor: statusFilter === status ? '#007bff' : '#f0f0f0',
//                 color: statusFilter === status ? '#fff' : '#000',
//                 border: 'none',
//                 borderRadius: '4px',
//                 cursor: loading ? 'not-allowed' : 'pointer',
//                 opacity: loading ? 0.7 : 1,
//               }}
//             >
//               {status}
//             </button>
//           ))}
//         </div>
//       </div>

//       {loading && offset === 0 && (
//         <p className={classes.textsmall}>Loading challenges…</p>
//       )}
//       {error && <p className={classes.textsmall} style={{ color: 'crimson' }}>{error}</p>}

//       {Array.isArray(visibleChallenges) && visibleChallenges.length > 0 ? (
//         <>
//           <div className={classes.grid3block}>
//             {visibleChallenges.map((item) => {
//               const {
//                 id,
//                 title,
//                 name,
//                 ideas,
//                 descWithoutTags,
//                 ends,
//                 categoryTypeId,
//                 sponsorEmail,
//                 creatorEmail,
//                 images,
//                 image,
//                 status: innovateStatus,
//               } = item || {};

//               // Robust end date formatting
//               let formattedEndDate = null;
//               try {
//                 const raw = ends?.dateString ?? ends ?? null;
//                 if (raw) {
//                   const d = new Date(raw);
//                   if (!Number.isNaN(d.getTime())) {
//                     formattedEndDate = format(d, 'dd MMM yyyy');
//                   }
//                 }
//               } catch {
//                 // ignore invalid date
//               }

//               const selectedType = innovateCategoryTypes.find(
//                 (t) => Number(t.id) === Number(categoryTypeId)
//               );

//               const imageUrl = images?.[0]?.url || image?.url || defaultImg;

//               return (
//                 <InnovateChallengeCard
//                   key={id}
//                   urlID={id ?? null}
//                   images={imageUrl}
//                   decs={descWithoutTags || ''}
//                   passAllDataToDetails={item}
//                   redirectLinkId={id}
//                   ideaSubmitted={ideas?.length || 0}
//                   challengeTitle={title || name}
//                   challengeOwner={creatorEmail || sponsorEmail}
//                   submissionsEnd={formattedEndDate}
//                   category={selectedType?.name}
//                   status={innovateStatus}
//                   selectedChallengeButtonDisbale
//                   myChallengeStatus
//                 />
//               );
//             })}
//           </div>

//           {/* Footer: counts + Load More */}
//           <div style={{ marginTop: '1.75rem', display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
//             {/* <p className={classes.textsmall}>
//               Showing {visibleCount} of {totalLabel}
//             </p> */}

//             {/* {hasMore && ( */}
//               <button
//                 type="button"
//                 onClick={() => setOffset((prev) => prev + limit)}
//                 disabled={loading}
//                 className={classes.viewlink}
//                 style={{
//                   padding: '8px 12px',
//                   // backgroundColor: '#007bff',
//                   // color: '#fff',
//                   // border: 'none',
//                   // borderRadius: '4px',
//                   cursor: loading ? 'not-allowed' : 'pointer',
//                   opacity: loading ? 0.7 : 1,
//                 }}
//                 aria-label="Load more challenges"
//               >
//                 {loading ? 'Loading…' : 'Load more'}
//               </button>
//              {/* )}  */}
//           </div>
//         </>
//       ) : (
//         !loading && <EmptyState classes={classes} />
//       )}
//     </>
//   );
// };



const RenderInnovateChallenge = ({
  listInnovateChallengeData = [],
  innovateCategoryTypes = [],
  isAdmin,
  isInnovator,
  getInnovateChallengeFilterListFn,
  enableIsHackathon,
  filterListInnovateChallengeTotal
}) => {

  const classes = useStyles();
  const [statusFilter, setStatusFilter] = useState('ACTIVE');
  const [offset, setOffset] = useState(0);
  const [challengeFilterAllData,setChallengeFilterAllData] = useState([]);
  const statusOptions = useMemo(
    () => ((isAdmin || isInnovator) ? ['ACTIVE', 'DRAFT', 'FINISHED'] : ['ACTIVE', 'FINISHED']),[isAdmin,isInnovator]
  );

  // console.log("listInnovateChallengeData ==>", listInnovateChallengeData)

 

  useEffect(() => {
    setChallengeFilterAllData([])
    setOffset(0);
    if(enableIsHackathon){    
      getInnovateChallengeFilterListFn(statusFilter, 0, CHALLENGE_PAGE_SIZE, enableIsHackathon);
     }
   }, [statusFilter,enableIsHackathon]);


  //  useEffect(()=>{
  //     setChallengeFilterAllData((prev)=> [...prev, ...listInnovateChallengeData])
  // },[listInnovateChallengeData])

  useEffect(()=>{
    setChallengeFilterAllData(prev => {
      const seen = new Set(prev.map(x => x.id));
      const onlyNew = listInnovateChallengeData.filter(x => !seen.has(x.id));
      return [...prev, ...onlyNew];
    });
  },[listInnovateChallengeData])

 const onClickLoadMore = () => {
  const currentOffset = offset || 0;
  console.log('offset',offset)
  const newLimit = currentOffset ? CHALLENGE_LOAD_MORE_SIZE : CHALLENGE_PAGE_SIZE
  const newOffset = newLimit + currentOffset

  // Call API with current offset and limit
  getInnovateChallengeFilterListFn(
    statusFilter,
    newOffset,
    CHALLENGE_LOAD_MORE_SIZE,
    enableIsHackathon,
  );

  // Update offset for next call
  setOffset(newOffset);
};

const sortedFiltered = React.useMemo(() => {
  return [...challengeFilterAllData].sort(
    (a, b) => (b?.starts?.timestamp ?? 0) - (a?.starts?.timestamp ?? 0)
  );
}, [challengeFilterAllData]);


// console.log("challengeFilterAllData==>", challengeFilterAllData, statusFilter)

  return(
    <>    
      <h2 className={classes.title}>All Challenges</h2>
      <div className={classes.filterContainer}>
        <p>Filter Challenges by Status</p>
        <div style={{ marginBottom: '1rem' }}>
          {statusOptions?.map((status) => (
            <button
              type="button"
              key={status}
              onClick={() => setStatusFilter(status)}
              // disabled={loading}
              style={{
                marginRight: '10px',
                padding: '6px 12px',
                backgroundColor: statusFilter === status ? '#007bff' : '#f0f0f0',
                color: statusFilter === status ? '#fff' : '#000',
                border: 'none',
                borderRadius: '4px',
                // cursor: loading ? 'not-allowed' : 'pointer',
                // opacity: loading ? 0.7 : 1,

              }}
            >
              {status}
            </button>
          ))}
        </div>
      </div>
      {Array.isArray(challengeFilterAllData) && challengeFilterAllData.length > 0 ? (
        <>
          <div className={classes.grid3block}>
            {sortedFiltered?.map((item) => {
              const {
                id,
                title,
                name,
                ideas,
                descWithoutTags,
                ends,
                categoryTypeId,
                sponsorEmail,
                creatorEmail,
                images,
                image,
                status: innovateStatus,
                isHackathonChallenge,
                isInnovate,
                numIdeas:innovateChallengeTagIdeaCount
              } = item || {};

              // Robust end date formatting
              let formattedEndDate = null;
              try {
                const raw = ends?.dateString ?? ends ?? null;
                if (raw) {
                  const d = new Date(raw);
                  if (!Number.isNaN(d.getTime())) {
                    formattedEndDate = format(d, 'dd MMM yyyy');
                  }
                }
              } catch {
                // ignore invalid date
              }

              const selectedType = innovateCategoryTypes.find(
                (t) => Number(t.id) === Number(categoryTypeId)
              );

              const imageUrl = image?.url || images?.[0]?.url || defaultImg;

              return (
                <InnovateChallengeCard
                  key={id}
                  urlID={id ?? null}
                  images={imageUrl}
                  decs={descWithoutTags || ''}
                  passAllDataToDetails={item}
                  redirectLinkId={id}
                  ideaSubmitted={ideas?.length || 0}
                  challengeTitle={title || name}
                  challengeOwner={creatorEmail || sponsorEmail}
                  submissionsEnd={formattedEndDate}
                  category={selectedType?.name}
                  status={innovateStatus}
                  selectedChallengeButtonDisbale
                  myChallengeStatus
                  isInnovate={isInnovate}
                  isHackathonChallenge={isHackathonChallenge}
                  innovateChallengeTagIdeaCount={innovateChallengeTagIdeaCount}
                  EndDate={formattedEndDate}
                />
              );

            })}
          </div>

          {
            isAdmin ? (
              filterListInnovateChallengeTotal === 1 ? null : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button type="button" className="viewlink" onClick={onClickLoadMore}>
                    Load more
                  </button>
                </div>
              )
            ) : null
          }


            {/* { filterListInnovateChallengeTotal > 1 &&
            
          <div className={classes.loadMoreWrapper} style={{ display: 'flex', justifyContent: 'center' }}>
            <button type='button' className={classes.viewlink} onClick={handleOnLoadMore}>
              Load more
            </button>
          </div>
           } */}
         
        </>
      ) : (<EmptyState classes={classes} />)
      }
    </>



  )
}
export default RenderInnovateChallenge;



